/*
 * Copyright (c) 2019. Sonrai Analytics Ltd.
 * Developed by Ryan Duffy
 */

import { Injectable } from '@angular/core';
import { NoteModel } from '@app/models/note.model';
import { ApiBaseService } from '@app/services/api-services/api-base.service';
import { HttpClient } from '@angular/common/http';
import { AuthUserService } from '@app/services/authentication/auth-user-service';
@Injectable({
  providedIn: 'root',
})
export class NotesListService extends ApiBaseService {
  private _notesList: NoteModel[] = [];
  protected _endpoint = 'notes';

  constructor(http: HttpClient, authUserService: AuthUserService) {
    super(http, authUserService);
  }

  get notesList(): NoteModel[] {
    return this._notesList;
  }

  set notesList(value: NoteModel[]) {
    this._notesList = value;
  }

  /**
   *  Ryan Duffy
   *
   *  getNoteByNoteId
   *
   * : Get an note based on the note_id by checking the list
   *
   * @param id of type string
   *
   * @returns Void: gets the note with the id that meets the query
   */
  getNoteByNoteId(noteId: string): NoteModel {
    for (const note of this.notesList) {
      if (note.noteId === noteId) {
        return note;
      }
    }
  }

  /**
   *  Ryan Duffy
   *
   *  addtoList
   *
   * : handles the insert of a new note into the list
   *
   * @param data of type NoteModel
   *
   * @returns Void: inserts a new note into the lsit
   */
  addToList(data: NoteModel): void {
    this.notesList.push(data);
  }
  /**
   *  Ryan Duffy
   *
   *  removeFromList
   *
   * : deletes an note from the list
   *
   * @param data of type NoteModel
   *
   * @returns Void: deletes a note
   */
  removeFromList(data: NoteModel): void {
    let index = 0;
    for (const note of this.notesList) {
      if (note.noteId === data.noteId) {
        this.notesList.slice(index, 1);
      }
      index++;
    }
  }
  /**
   *  Ryan Duffy
   *
   *  updateInList
   *
   * : handles the update of an note in the list
   *
   * @param data of type notemodel
   *
   * @returns Void: update the list with the data
   */
  updateInList(data: NoteModel): void {
    for (let note of this.notesList) {
      if (note.noteId === data.noteId) {
        note = data;
      }
    }
  }
  /**
   *  Ryan Duffy
   *
   *  handleData
   *
   * : handles the data from the list by extending the handleData function from the API base service
   *
   * @param data of type NoteModel
   *
   * @returns Void: get the note from the postgres database and create the list
   */
  protected handleData(data: any): void {
    this.notesList = [];
    let note: NoteModel;
    super.handleData(data);
    for (const item of data) {
      note = new NoteModel();
      this.addToList(note.fromJson(item));
    }
  }
}
